import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark py-8 border-t border-gray-800 text-center" data-id="element-131">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-132">
        <p className="text-gray-500 text-sm" data-id="element-133">
          &copy; {new Date().getFullYear()} Richard M Oblath. All rights
          reserved.
        </p>
      </div>
    </footer>;
}